module.exports = __webpack_public_path__ + "img/95.b83d5274.jpg";